import gql from 'graphql-tag';
import { query } from 'services/graphql';

export const homeSurfaceQuery = gql`
  query homeSurface {
    homeSurface {
      error
      data {
        id
      }
    }
  }
`;

export default query(homeSurfaceQuery);
